module.exports = __webpack_public_path__ + "static/media/elo.29405648.svg";